import { defineStore } from 'pinia';
import { ref } from 'vue';

const PAGE_SIZES = [10, 20, 30, 40, 50] as const;

export const useGeneralStore = defineStore('generalStore', {
  state: () => {
    const passwordReset = ref(false); // Will be used in otp screen for redirect
    const passwordResetFallbackToWhatsApp = ref(false);
    const notifyUrl = ref('');
    const iFrame = ref(false);
    const isMenuOpen = ref(false);
    const pageSize = ref(10);

    return { passwordReset, passwordResetFallbackToWhatsApp, notifyUrl, iFrame, isMenuOpen, pageSize };
  },
  actions: {
    reset() {
      this.$reset();
    },
    getPageSizeOptions(): readonly number[] {
      return PAGE_SIZES;
    },
  },
  persist: true,
});
